import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from "../hooks/useAuth";
import Loading from "../../components/status/Loading";

interface PrivateRouteProps {
}

const PrivateRoute: React.FC<PrivateRouteProps> = () => {
    const {isAuthenticated, isLoading} = useAuth();
    const location = useLocation();

    if (isLoading) return <Loading/>;
    if (!isAuthenticated) return <Navigate to="/login" state={{from: location}}/>;

    return <Outlet/>;
};

export default PrivateRoute;
